import { render, staticRenderFns } from "./FSCGroups.vue?vue&type=template&id=bf41a0ec&"
import script from "./FSCGroups.vue?vue&type=script&lang=js&"
export * from "./FSCGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports